import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Generic } from '../../models/generic';
import { CarStatistics } from '../../models/car-statistics';
import { AddParamsService, Params } from '../utilis/add-params-service';
import { RideStatistics } from '../../models/ride-statistics';
import { CustomerStatistics } from '../../models/customer-statistics';
import { RevenueStatistics } from '../../models/revenue-statistics';
import { RevenueChartResponse } from '../../models/revenue-chart';
import { RideChartResponse } from '../../models/ride-chart';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  private baseUrl = environment.url;
  private addParamsService = inject(AddParamsService)


  private http = inject(HttpClient)

  getCarStatistics = (): Observable<Generic<CarStatistics>> => {
    return this.http.get<Generic<CarStatistics>>(`${this.baseUrl}/dashboard/car-statistics`);
  }

  getRideStatistics = (params?: Params): Observable<Generic<RideStatistics>> => {
    return this.http.get<Generic<RideStatistics>>(`${this.baseUrl}/dashboard/ride-statistics`, {
      params: this.addParamsService.addParams(params)
    });
  }

  getRevenueStatistics = (params?: Params): Observable<Generic<RevenueStatistics>> => {
    return this.http.get<Generic<RevenueStatistics>>(`${this.baseUrl}/dashboard/revenue-statistics`, {
      params: this.addParamsService.addParams(params)
    });
  }

  getCustomerStatistics = (params?: Params): Observable<CustomerStatistics> => {
    return this.http.get<CustomerStatistics>(`${this.baseUrl}/dashboard/customer-statistics`, {
      params: this.addParamsService.addParams(params)
    });
  }

  getRevenueAreaChart = (params?: Params): Observable<Generic<RevenueChartResponse>> => {
    return this.http.get<Generic<RevenueChartResponse>>(
      `${this.baseUrl}/dashboard/revenue-area-chart`,
      {
        params: this.addParamsService.addParams(params)
      });
  }

  getRideAreaChart = (params?: Params): Observable<Generic<RideChartResponse>> => {
    return this.http.get<Generic<RideChartResponse>>(
      `${this.baseUrl}/dashboard/rides-area-chart`,
      {
        params: this.addParamsService.addParams(params)
      });
  }
}
